<template>
  <div
    v-if="visible"
    class="bloqueo-root"
    @click.prevent
    @touchmove.prevent
  >
    <div class="bloqueo-wrap" @click.stop>
      <div class="bloqueo-card" :class="escuelaClass">
        <div class="bloqueo-blob bloqueo-blob-a"></div>
        <div class="bloqueo-blob bloqueo-blob-b"></div>

        <div class="bloqueo-illu">
          <v-icon class="bloqueo-illu-icon">mdi-storefront-outline</v-icon>
        </div>

        <p class="bloqueo-msg">{{ mensaje }}</p>

        <div class="bloqueo-timer" aria-live="polite">
          <svg class="bloqueo-ring" viewBox="0 0 96 96">
            <circle class="bloqueo-ring-bg" cx="48" cy="48" r="40" />
            <circle
              class="bloqueo-ring-fg"
              cx="48"
              cy="48"
              r="40"
              :stroke-dasharray="ringLen"
              :stroke-dashoffset="ringOffset"
            />
          </svg>
          <div class="bloqueo-count">{{ restantes }}</div>
        </div>

        <p class="bloqueo-hint">
          Cerraremos tu sesión en {{ restantes }} segundo{{ restantes === 1 ? '' : 's' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { busBloqueoCiclo, esBloqueoCiclo } from '@/utils/bloqueoCiclo'

const RING = 2 * Math.PI * 40

export default {
  name: 'BloqueoCiclo',

  data () {
    return {
      visible: false,
      mensaje: '',
      restantes: 30,
      total: 30,
      timer: null,
      cerrado: false,
      ringLen: RING,
    }
  },

  computed: {
    ...mapGetters('login', ['getUsuarioLMS', 'getLogeadoLMS', 'getEscuela']),
    esAlumno () {
      const u = this.getUsuarioLMS
      if (!u) return false
      const roll = u.roll
      return roll === 'ALUMNO' || roll === 1 || Number(roll) === 1
    },
    escuelaClass () {
      return Number(this.getEscuela) === 1 ? 'is-inbi' : 'is-fast'
    },
    ringOffset () {
      const t = this.total || 30
      const p = Math.max(0, Math.min(1, this.restantes / t))
      return RING * (1 - p)
    },
  },

  created () {
    busBloqueoCiclo.$on('mostrar', this.mostrar)
    this.$root.$on('bloqueo-ciclo', this.mostrar)
  },

  watch: {
    getLogeadoLMS: {
      immediate: true,
      handler (logeado) {
        if (!logeado) {
          this.visible = false
          this.cerrado = false
          this.limpiarTimer()
          return
        }
        this.cerrado = false
        this.revisar()
      },
    },
  },

  beforeDestroy () {
    this.limpiarTimer()
    busBloqueoCiclo.$off('mostrar', this.mostrar)
    this.$root.$off('bloqueo-ciclo', this.mostrar)
  },

  methods: {
    ...mapActions('login', ['salirLogin']),

    limpiarTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    revisar () {
      if (!this.getLogeadoLMS || !this.esAlumno || !this.getUsuarioLMS || !this.getUsuarioLMS.id) {
        this.visible = false
        this.limpiarTimer()
        return
      }

      this.$http.get('usuario.acceso.ciclo/' + this.getUsuarioLMS.id).then((response) => {
        if (esBloqueoCiclo(response)) this.mostrar(response.body || response)
      }).catch((error) => {
        if (esBloqueoCiclo(error)) this.mostrar(error)
      })
    },

    mostrar (body) {
      if (this.visible) return
      this.cerrado = false
      const data = body && (body.body || body)
      this.mensaje = (data && (data.message || data.mensaje)) || 'Vemos que tu pago no se ha reflejado en nuestro sistema, por favor comunícate con tu sucursal.'
      const segs = Math.max(5, Number(data && data.segundos) || 30)
      this.total = segs
      this.restantes = segs
      this.visible = true
      this.limpiarTimer()
      this.timer = setInterval(() => {
        this.restantes -= 1
        if (this.restantes <= 0) this.cerrarApp()
      }, 1000)
    },

    cerrarApp () {
      if (this.cerrado) return
      this.cerrado = true
      this.limpiarTimer()
      try {
        this.salirLogin()
      } catch (e) {}
      try {
        const Cap = typeof window !== 'undefined' ? window.Capacitor : null
        const AppPlugin = Cap && Cap.Plugins && Cap.Plugins.App
        if (AppPlugin && typeof AppPlugin.exitApp === 'function') AppPlugin.exitApp()
      } catch (e) {}
    },
  },
}
</script>

<style scoped>
.bloqueo-root {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(143, 184, 201, 0.35);
}

.bloqueo-wrap {
  padding: 20px;
  max-width: 440px;
}

.bloqueo-card {
  position: relative;
  overflow: hidden;
  background: #f7fbfc;
  border-radius: 28px;
  padding: 36px 28px 28px;
  text-align: center;
  box-shadow: 0 18px 50px rgba(15, 55, 80, 0.12);
}

.bloqueo-blob {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  opacity: 0.55;
}

.bloqueo-blob-a {
  width: 160px;
  height: 160px;
  top: -70px;
  right: -50px;
  background: #d7f1f4;
}

.bloqueo-blob-b {
  width: 110px;
  height: 110px;
  bottom: -40px;
  left: -30px;
  background: #e8f4ee;
}

.is-inbi .bloqueo-blob-a { background: #d9e8f2; }
.is-inbi .bloqueo-blob-b { background: #e7eef6; }

.bloqueo-illu {
  position: relative;
  width: 88px;
  height: 88px;
  margin: 0 auto 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #e8f8fa 0%, #cfeef2 100%);
}

.is-inbi .bloqueo-illu {
  background: linear-gradient(160deg, #eaf3f8 0%, #d2e4f0 100%);
}

.bloqueo-illu-icon {
  font-size: 40px !important;
  color: #3aa8b5 !important;
}

.is-inbi .bloqueo-illu-icon {
  color: #4f7fa3 !important;
}

.bloqueo-msg {
  position: relative;
  margin: 0 0 22px;
  color: #3a5563;
  font-size: 16px;
  line-height: 1.55;
  font-weight: 400;
}

.bloqueo-timer {
  position: relative;
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
}

.bloqueo-ring {
  width: 96px;
  height: 96px;
  transform: rotate(-90deg);
}

.bloqueo-ring-bg,
.bloqueo-ring-fg {
  fill: none;
  stroke-width: 6;
}

.bloqueo-ring-bg { stroke: #e4eef1; }
.bloqueo-ring-fg {
  stroke: #7dc9d2;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.9s linear;
}

.is-inbi .bloqueo-ring-fg { stroke: #7ea3c2; }

.bloqueo-count {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 600;
  color: #4a6a78;
}

.bloqueo-hint {
  position: relative;
  margin: 0;
  color: #7a939e;
  font-size: 13px;
  line-height: 1.4;
}
</style>
